module.exports = __webpack_public_path__ + "img/US.eadfb4ed.svg";